import { jsx as _jsx } from "react/jsx-runtime";
import { AppIcon } from './AppIcon.js';
import cls from './GlobalLoader.module.css';
export function GlobalLoader() {
    return (_jsx("div", { className: cls.root, children: _jsx(AppIcon, { className: cls.logo }) }));
}
//# sourceMappingURL=GlobalLoader.js.map